import fonts from '../theme/foundations/fonts';
const baseStyle = {
    color: 'darkBlue.main'
};
const defaultProps = {
    size: 'h2'
};
const sizes = {
    title: {
        as: 'h1',
        fontFamily: [fonts.dnvDisplay, fonts.avenir].join(', '),
        fontSize: {
            desktop: '64px',
            mobile: '42px'
        },
        fontWeight: 'medium',
        lineHeight: {
            desktop: '74px',
            mobile: '52px'
        }
    },
    h1: {
        as: 'h1',
        fontSize: {
            desktop: '50px',
            mobile: '36px'
        },
        fontWeight: 'regular',
        lineHeight: {
            desktop: '62px',
            mobile: '48px'
        }
    },
    lead: {
        as: 'h2',
        color: 'seaBlue.main',
        fontSize: {
            desktop: '28px',
            mobile: '20px'
        },
        fontWeight: 'regular',
        lineHeight: {
            desktop: '38px',
            mobile: '28px'
        }
    },
    h2: {
        as: 'h2',
        fontSize: {
            desktop: '32px',
            mobile: '28px'
        },
        fontWeight: 'regular',
        lineHeight: {
            desktop: '42px',
            mobile: '38px'
        }
    },
    h3: {
        as: 'h3',
        fontSize: {
            desktop: '24px',
            mobile: '22px'
        },
        fontWeight: 'regular',
        lineHeight: '32px'
    },
    h4: {
        as: 'h4',
        fontSize: {
            desktop: '20px',
            mobile: '18px'
        },
        fontWeight: 'demi',
        lineHeight: '24px'
    },
    h5: {
        as: 'h5',
        fontSize: {
            desktop: '18px',
            mobile: '16px'
        },
        fontWeight: 'demi',
        lineHeight: {
            desktop: '26px',
            mobile: '22px'
        }
    },
    h6: {
        as: 'h6',
        fontSize: '16px',
        fontWeight: 'demi',
        lineHeight: '22px'
    }
};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
